import React, { useState } from "react";

// Import images from assets folder
import cateringSetup1Video from "../assets/cateringSetup1.mp4";
import cat2 from "../assets/cat2.webp";
import cat3 from "../assets/cat3.webp";
import cat4 from "../assets/cat4.png";
import cat5 from "../assets/cat5.webp";
import Image_2 from "../assets/Image_2.jpg";
import Image_5 from "../assets/Image_5.jpg";
import Image_9 from "../assets/Image_9.jpg";
import Image_18 from "../assets/Image_18.jpg";
import Image_21 from "../assets/Image_21.webp";
import Image_29 from "../assets/Image_29.jpg";
import Image_31 from "../assets/Image_31.jpg";
import Image_37 from "../assets/Image_37.jpg";

export default function Gallery() {
    const [showAll, setShowAll] = useState(false);

    const images = [
        { src: cateringSetup1Video, title: "Preperation", type: "video" },
        { src: cat2, title: "Catering Setup 2" },
        { src: cat3, title: "Catering Setup 3" },
        { src: cat4, title: "Catering Setup 4" },
        { src: cat5, title: "Catering Setup 5" },
        { src: Image_2, title: "Gallery Image 2" },
        { src: Image_5, title: "Gallery Image 5" },
        { src: Image_9, title: "Gallery Image 9" },
        { src: Image_18, title: "Gallery Image 18" },
        { src: Image_21, title: "Gallery Image 21" },
        { src: Image_29, title: "Gallery Image 29" },
        { src: Image_31, title: "Gallery Image 31" },
        { src: Image_37, title: "Gallery Image 37" },
    ];

    const visibleImages = showAll ? images : images.slice(0, 6);

    return (
        <section
            id="gallery"
            className="py-24 px-6 md:px-20 text-center font-[Playfair_Display]"
            style={{
                background: "#FFFFFF",
                color: "#1F2937",
            }}
        >
            {/* Header */}
            <div className="mb-12">
                <h2 className="text-4xl md:text-5xl font-semibold mb-4 text-[#1F2937]">
                    Our Culinary <span className="text-[#D4AF37]">Gallery</span>
                </h2>
                <p className="text-[#4B5563] text-lg max-w-2xl mx-auto italic">
                    A glimpse into our kitchen — where tradition meets flavor and presentation.
                </p>
            </div>

            {/* Image Grid */}
            <div
                className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 transition-all duration-700 ${
                    showAll ? "max-h-[9999px]" : "max-h-[1100px] overflow-hidden"
                }`}
            >
                {visibleImages.map((img, i) => (
                    <div
                        key={i}
                        className="relative group overflow-hidden rounded-2xl border border-[#D4AF37]/30 shadow-[0_4px_20px_rgba(0,0,0,0.3)] hover:shadow-[0_6px_25px_rgba(212,175,55,0.3)] transition-all duration-300"
                    >
                        {img.type === "video" ? (
                            <video
                                src={img.src}
                                autoPlay
                                loop
                                muted
                                playsInline
                                className="w-full h-72 object-cover transform group-hover:scale-110 transition duration-500 ease-in-out"
                            />
                        ) : (
                            <img
                                src={img.src}
                                alt={img.title}
                                className="w-full h-72 object-cover transform group-hover:scale-110 transition duration-500 ease-in-out"
                            />
                        )}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 flex items-center justify-center transition duration-500">
                            <p className="text-[#D4AF37] text-xl font-semibold px-4 drop-shadow-[0_2px_5px_rgba(0,0,0,0.6)]">
                                {img.title}
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Show More / Less Button */}
            <div className="mt-12">
                <button
                    onClick={() => setShowAll(!showAll)}
                    className="px-8 py-3 rounded-full font-semibold transition-all duration-300 shadow-[0_4px_20px_rgba(212,175,55,0.3)] hover:shadow-[0_4px_30px_rgba(212,175,55,0.4)]"
                    style={{
                        background: "linear-gradient(135deg, #D4AF37 0%, #e0c168 100%)",
                        color: "#FFFFFF",
                    }}
                >
                    {showAll ? "Show Less" : "View Full Gallery"}
                </button>
            </div>
        </section>
    );
}